import { TmSelectPopupComponent } from './components/tm-select/tm-select-popup/tm-select-popup.component';
import { TmPopupEntryComponent } from './components/tm-select/tm-popup-entry/tm-popup-entry.component';
import { ListPopupComponent } from './components/tm-select/list-popup/list-popup.component';
import { MatDialogModule } from '@angular/material/dialog';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './components/button/button.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { DateFormatComponent } from './components/date/date.component';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { DateTimePickerComponent } from './components/date-time-picker/date-time-picker.component';
import { DynamicSectionComponent, DynamicFieldConditionCheckPipe, DynamicFieldMasterTitle, DynamicFilesTitlePipe, PhoneNumberPipe, VerifyCheck, DynamicFieldProcessingPipe, AddNgStylePipe, DecodeHTML } from './components/dynamic-section/dynamic-section.component';
import { DynamicFormComponent, DynamicSectionConditionCheckPipe, FetchColumnsFromFields, DynamicFieldsMasterTitle, DynamicFieldsMasterTitleTable, JSONParser, HTMLFormatter, JSONParserAssign, HideOption, StripHTMLTags } from './components/dynamic-form/dynamic-form.component';
import { FilesComponent } from './components/files/files.component';
import { FilesModalComponent } from './components/files-modal/files-modal.component';
import { MatSelectSearchComponent } from './components/mat-select-search/mat-select-search.component';
import { NumberComponent } from './components/number/number.component';
import { PasswordComponent } from './components/password/password.component';
import { RadioComponent } from './components/radio/radio.component';
import { SliderRangeComponent } from './components/slider-range/slider-range.component';
import { TallintTableComponent, TallintTableRowComponent, TableRowCSS, CheckGridConditions, SafeHtmlPipe, InnerHTMLToText, checkStyleConditionRow } from './components/tallint-table/tallint-table.component';
import { TextComponent } from './components/text/text.component';
import { TextareaComponent } from './components/textarea/textarea.component';
import { TmMultiSelectComponent, TMSelectIconCondition } from './components/tm-multi-select/tm-multi-select.component';
import { TMSelectComponent } from './components/tm-select/tm-select.component';
import { NestedOptionsComponent } from './components/tm-multi-select/nested-options/nested-options.component';
import { ToggleComponent } from './components/toggle/toggle.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SliderComponent } from './components/slider/slider.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ErrorStateMatcher, ShowOnDirtyErrorStateMatcher, DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { MatExpansionModule } from '@angular/material/expansion';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ImageCropperComponent } from './components/image-cropper/image-cropper.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { HTMLTextEditorComponent } from './components/html-text-editor/html-text-editor.component';
import { SharedModule } from '../shared.module';
import { ColumnDetailsComponent } from './components/tallint-table/column-details/column-details.component';
import { PhoneNumberComponent } from './components/phone-number/phone-number.component';
import { MatDatetimepickerModule, MatNativeDatetimeModule, MAT_DATETIME_FORMATS } from '@mat-datetimepicker/core';
import { MomentDateModule, MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { TimelineComponent } from './components/timeline/timeline.component';
import { EmailsComponent } from './components/emails/emails.component';
import { AttachmentsViewComponent } from './components/attachment-view/attachment-view.component';
import { DocumentViewPopupComponent } from './components/document-view-popup/document-view-popup.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { SafeFilePipe, evalPipe, SanitizePipe } from '../pipes/shared/SafeFilePipe';
import { EmailModelViewComponent } from './components/emails/email-model-view/email-model-view.component';
import { UTCtoLocalPipe } from '../pipes/shared/utc-to-local/utc-to-local';
import { TmBasicSelectComponent } from './components/tm-basic-select/tm-basic-select.component';
import { AssessmentComponent } from './components/assessment/assessment.component';
import { ViewAssessmentsComponent } from './components/assessment/view-assessments/view-assessments.component';
import { FilesComponentDuplicate } from '../modules/shared/files/files.component';
import { FileViewerComponent } from './components/file-viewer/file-viewer.component';
import { TableComponent } from './components/table/table.component';
import { ParagraphComponent } from './components/paragraph/paragraph.component';
// import {NgcFloatButtonModule} from 'ngc-float-button';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { DOMHandlerDirective } from './directives/DOMhandler.directive';
import { LoaderModule } from '../modules/loader/loader.module';
import { DestoryDirective, ContextMenuDirective, NgInitDirective } from './directives/onDestroy.directive';
import { RatingComponent } from './components/rating/rating.component';
import { MatMenuModule } from '@angular/material/menu';
import { NestedCommandsComponent } from './components/dynamic-form//nested-commands/nested-commands.component';
// import { CustomControlComponent } from './components/phone-number/custom-control/custom-control.component';
import { PortalModule } from '@angular/cdk/portal';
import { TMPaginationComponent } from './components/tm-pagination/tm-pagination.component';
import { ProfilePictureComponent } from './components/profile-picture/profile-picture.component';
import { AvailabilityComponent } from './components/availability/availability.component'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { QRViewerComponent } from './components/files-modal/qr-viewer/qr-viewer.component';
import { TmRecaptchaComponent } from './components/tm-recaptcha/tm-recaptcha.component';
import { NotesDataComponent } from './components/notes-data/notes-data.component';
import { FilterComponent } from './components/filter/filter.component';
import { ViewApprovalHistoryComponent } from './components/view-approval-history/view-approval-history.component';
import { checkStyleCondition, checkTemplateCondition, cloneArrayPipe, DynamicFormFieldProcessingPipe, DynamicFormSectionProcessingPipe, HTMLFormatterDecode, MasterTitlePipe, safeHTMLPipe, TMsafeHTMLPipe } from './pipes/shared-pipes';
import { DynamicDialogComponent } from './components/dynamic-dialog/dynamic-dialog.component';
import { DashboardFilterDirective } from '../directive/dashboard-filter.directive';
import { AccessRightsPipe } from '../pipes/shared/access-rights.pipe';
import { IcrFileComponent } from './components/icr-file/icr-file.component';
import { StarRatingComponent } from './components/star-rating/star-rating.component';
import { DigitalSignatureComponent } from './components/digital-signature/digital-signature.component'
import { SectionProgressPipe } from './pipes/section-progress.pipe';
import { TmDynamicFormV2Component } from './components/tm-dynamic-form-v2/tm-dynamic-form-v2.component';
import { FileUploadAndPreviewComponent } from './components/file-upload-and-preview/file-upload-and-preview.component';
import { ChatBotComponent } from './components/chat-bot/chat-bot.component';
import { GoogleMapsPopupComponent } from '../modules/shared/google-maps-popup/google-maps-popup.component';
import { LocationComponent } from '../modules/shared/location/location.component';
import { TmToggleComponent } from './components/tm-toggle/tm-toggle.component';
import { DateAgoPipe, DynamicFilterPipe } from '../functions/shared-functions';
import { SkillRatingComponent } from './components/skill-rating/skill-rating.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { EducationComponent } from './components/education/education.component';
import { MonthYearComponent } from './components/month-year/month-year.component';
import { CvLocationComponent } from './components/cv-location/cv-location/cv-location.component';
import { CvMapComponent } from './components/cv-location/cv-map/cv-map.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { MultiCheckboxComponent } from './components/multi-checkbox/multi-checkbox.component';
import { CarouselComponent } from './components/carousel/carousel.component';
import { MaskPasswordComponent } from './components/mask-password/mask-password.component';
import { TmCheckboxComponent } from './components/tm-checkbox/tm-checkbox.component';
import { ExtFieldsComponent } from './components/ext-fields/ext-fields.component';
import { TmCaptchComponent } from './components/tm-captch/tm-captch.component';
import { TmDynamicFormV3Component } from './components/tm-dynamic-form-v3/tm-dynamic-form-v3.component';
import { TmDataTableComponent } from './components/tm-data-table/tm-data-table.component';
import { TmDynamicChecklistComponent } from './components/tm-dynamic-checklist/tm-dynamic-checklist.component';
import { TmDynamicAssessmentComponent } from './components/tm-dynamic-assessment/tm-dynamic-assessment.component';
import { TmDynamicDocumentsComponent } from './components/tm-dynamic-documents/tm-dynamic-documents.component';
import { TmDigitalSignatureComponent } from './components/tm-digital-signature/tm-digital-signature.component';
import { TmDeclarationDocumentsComponent } from './components/tm-declaration-documents/tm-declaration-documents.component';
import { DynamicPhoneNumberComponent } from './components/dynamic-phone-number/dynamic-phone-number.component';
import { TmAddressComponent } from './components/tm-address/tm-address.component';
import { TmVerificationStatusComponent } from './components/tm-verification-status/tm-verification-status.component';
import { ChatsComponent } from './components/chat-bot/chats/chats.component';
import { TmDecalrationDocumentsViewComponent } from './components/tm-decalration-documents-view/tm-decalration-documents-view.component';
import { NgxDovViewerComponent } from './components/ngx-dov-viewer/ngx-dov-viewer.component';
import { ExcelViewComponent } from './components/document-view-popup/excel-view/excel-view.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { TmProfilePictuteComponent } from './components/tm-profile-pictute/tm-profile-pictute.component';
import { DateTimePickerT2Component } from './components/date-time-picker-t2/date-time-picker-t2.component';
import { MatDatetimepickerT2Module } from './components/date-time-picker-t2/core/src/datetimepicker';
import { extendedFieldsDirective } from './directive/shared-directives.directive';
import { ConfirmPasswordComponent } from './components/confirm-password/confirm-password.component';
import { DynamicFieldConfigProcessing } from './functions/shared-functions';
import { SignatureModalComponent } from './components/tm-digital-signature/signature-modal/signature-modal.component';
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule, NgxMatNativeDateModule, NGX_MAT_DATE_FORMATS } from '@angular-material-components/datetime-picker';
import { HTMLTextEditorV2Component } from './components/html-text-editor-v2/html-text-editor-v2.component';

// import { ClipboardModule } from '@angular/cdk';

@NgModule({
  declarations: [
    ButtonComponent,
    CheckboxComponent,
    DateFormatComponent,
    DatePickerComponent,
    DateTimePickerComponent,
    // DynamicSectionModalComponent,
    DynamicFormComponent,
    FilesComponent,
    FilesModalComponent,
    VerifyCheck,
    ImageCropperComponent,
    MatSelectSearchComponent,
    NumberComponent,
    PasswordComponent,
    RadioComponent,
    SliderComponent,
    SliderRangeComponent,
    TallintTableComponent,
    TallintTableRowComponent,
    TextComponent,
    TextareaComponent,
    TmMultiSelectComponent,
    TMSelectComponent,
    ToggleComponent,
    HTMLTextEditorComponent,
    DynamicFieldConditionCheckPipe,
    DynamicFilesTitlePipe,
    DynamicFieldMasterTitle,
    DynamicSectionConditionCheckPipe,
    FetchColumnsFromFields,
    DynamicFieldsMasterTitle,
    TmBasicSelectComponent,
    DynamicSectionComponent,
    FilesComponent,
    ColumnDetailsComponent,
    PhoneNumberComponent,
    DynamicFieldsMasterTitleTable,
    PhoneNumberPipe,
    JSONParser,
    JSONParserAssign,
    TableRowCSS,
    CheckGridConditions,
    TimelineComponent,
    AttachmentsViewComponent,
    EmailsComponent,
    DocumentViewPopupComponent,
    ContactUsComponent,
    HTMLFormatter,
    SafeFilePipe,
    EmailModelViewComponent,
    UTCtoLocalPipe,
    SafeHtmlPipe,
    TMsafeHTMLPipe,
    AssessmentComponent,
    ViewAssessmentsComponent,
    FileViewerComponent,
    TableComponent,
    // DynamicSectionsComponent
    DOMHandlerDirective,
    HideOption,
    DynamicFieldProcessingPipe,
    AddNgStylePipe,
    DecodeHTML,
    DestoryDirective,
    ContextMenuDirective,
    RatingComponent,
    evalPipe,
    SanitizePipe,
    NestedCommandsComponent,
    // CustomControlComponent,
    TMPaginationComponent,
    // MasterTitlePipe,
    ParagraphComponent,
    ProfilePictureComponent,
    StripHTMLTags,
    AvailabilityComponent,
    QRViewerComponent,
    TmRecaptchaComponent,
    NestedOptionsComponent,
    NotesDataComponent,
    // BulkFormComponent,
    FilterComponent,
    ViewApprovalHistoryComponent,
    MasterTitlePipe,
    DynamicDialogComponent,
    DashboardFilterDirective,
    AccessRightsPipe,
    IcrFileComponent,
    NgInitDirective,
    StarRatingComponent,
    safeHTMLPipe,
    ChatBotComponent,
    TmDynamicFormV2Component,
    DigitalSignatureComponent,
    SectionProgressPipe,
    TmDynamicFormV2Component,
    FileUploadAndPreviewComponent,
    ChatBotComponent,
    GoogleMapsPopupComponent,
    LocationComponent,
    TmToggleComponent,
    DynamicFilterPipe,
    SkillRatingComponent,
    EducationComponent,
    MonthYearComponent,
    HTMLFormatter,
    CvLocationComponent,
    CvMapComponent,
    MultiCheckboxComponent,
    CarouselComponent,
    MaskPasswordComponent,
    TmCheckboxComponent,
    ExtFieldsComponent,
    TmCaptchComponent,
    TmDynamicFormV3Component,
    TmAddressComponent,
    DynamicPhoneNumberComponent,
    RadioComponent,
    TmDataTableComponent,
    TmDynamicChecklistComponent,
    TmDynamicAssessmentComponent,
    TmDynamicDocumentsComponent,
    CheckboxComponent,
    TmDigitalSignatureComponent,
    DynamicFormFieldProcessingPipe,
    TmDeclarationDocumentsComponent,
    checkTemplateCondition,
    checkStyleCondition,
    TmVerificationStatusComponent,
    ChatsComponent,
    TmDecalrationDocumentsViewComponent,
    NgxDovViewerComponent,
    ExcelViewComponent,
    TmProfilePictuteComponent,
    cloneArrayPipe,
    DateAgoPipe,
    DateTimePickerT2Component,
    TMSelectIconCondition,
    ListPopupComponent,
    TmPopupEntryComponent,
    TmSelectPopupComponent,
    extendedFieldsDirective,
    ConfirmPasswordComponent,
    DynamicFormSectionProcessingPipe,
    DynamicFieldConfigProcessing,
    SignatureModalComponent,
    InnerHTMLToText,
    checkStyleConditionRow,
    HTMLTextEditorV2Component,
    HTMLFormatterDecode

  ],
  imports: [
    CommonModule,
    FormsModule,
    MatMenuModule,
    ReactiveFormsModule,
    MatInputModule,
    ImageCropperModule,
    MatExpansionModule,
    // Ng5SliderModule,
    MatSelectModule,
    SharedModule,
    MatDatepickerModule,
    MatTabsModule,
    MatStepperModule,
    MatIconModule,
    ScrollingModule,
    MatRadioModule,
    MatSliderModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatListModule,
    MomentDateModule,
    MatCardModule,
    MatDatetimepickerModule,
    MatNativeDatetimeModule,
    AngularEditorModule,
    LoaderModule,
    NgbModule,
    MatChipsModule,
    GoogleMapsModule,
    NgxDocViewerModule,
    // ClipboardModule,
    // NgcFloatButtonModule,
    TranslateModule.forChild({
      // loader: {
      //   provide: TranslateLoader,
      //   useFactory: HttpLoaderFactory,
      //   deps: [HttpClient]
      // }
    }),
    MatTooltipModule,
    DragDropModule,
    MatButtonModule,
    PortalModule,
    NgxSliderModule,
    MatDatetimepickerT2Module,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule
  ],
  exports: [
    TMSelectComponent,
    TmDynamicFormV3Component,
    ButtonComponent,
    CheckboxComponent,
    DateFormatComponent,
    DatePickerComponent,
    DateTimePickerComponent,
    DynamicSectionComponent,
    // DynamicSectionsComponent,
    // DynamicSectionModalComponent,
    DynamicFormComponent,
    FilesComponent,
    FilesModalComponent,
    ImageCropperComponent,
    MatSelectSearchComponent,
    NumberComponent,
    PasswordComponent,
    RadioComponent,
    SliderComponent,
    SliderRangeComponent,
    TallintTableComponent,
    TallintTableRowComponent,
    TextComponent,
    TextareaComponent,
    TmMultiSelectComponent,
    ToggleComponent,
    DynamicFieldConditionCheckPipe,
    HTMLTextEditorComponent,
    DynamicFieldMasterTitle,
    DynamicSectionConditionCheckPipe,
    DynamicFilesTitlePipe,
    FetchColumnsFromFields,
    DynamicFieldsMasterTitle,
    FilesComponent,
    AttachmentsViewComponent,
    ColumnDetailsComponent,
    PhoneNumberComponent,
    DynamicFieldsMasterTitleTable,
    PhoneNumberPipe,
    JSONParser,
    JSONParserAssign,
    TimelineComponent,
    HTMLFormatter,
    SafeFilePipe,
    DynamicFieldProcessingPipe,
    EmailsComponent,
    UTCtoLocalPipe,
    TmBasicSelectComponent,
    ViewAssessmentsComponent,
    AssessmentComponent,
    FileViewerComponent,
    TableComponent,
    AngularEditorModule,
    DOMHandlerDirective,
    DestoryDirective,
    ContextMenuDirective,
    RatingComponent,
    evalPipe,
    AddNgStylePipe,
    SanitizePipe,
    NestedCommandsComponent,
    TMPaginationComponent,
    // MasterTitlePipe,
    ParagraphComponent,
    StripHTMLTags,
    AvailabilityComponent,
    NestedOptionsComponent,
    NotesDataComponent,
    FilterComponent,
    ViewApprovalHistoryComponent,
    MasterTitlePipe,
    IcrFileComponent,
    NgInitDirective,
    StarRatingComponent,
    safeHTMLPipe,
    TmDynamicFormV2Component,
    DigitalSignatureComponent,
    SectionProgressPipe,
    TmDynamicFormV2Component,
    FileUploadAndPreviewComponent,
    ChatBotComponent,
    GoogleMapsPopupComponent,
    LocationComponent,
    TmToggleComponent,
    TranslateModule,
    DynamicFilterPipe,
    EducationComponent,
    MonthYearComponent,
    MultiCheckboxComponent,
    CarouselComponent,
    MaskPasswordComponent,
    TmCheckboxComponent,
    ExtFieldsComponent,
    TmRecaptchaComponent,
    TmCaptchComponent,
    checkTemplateCondition,
    checkStyleCondition,
    TmVerificationStatusComponent,
    ChatBotComponent,
    NgxDovViewerComponent,
    ExcelViewComponent,
    TmProfilePictuteComponent,
    cloneArrayPipe,
    DateAgoPipe,
    DateTimePickerT2Component,
    TMSelectIconCondition,
    DocumentViewPopupComponent,
    DynamicFieldConfigProcessing,
    TMsafeHTMLPipe,
    HTMLTextEditorV2Component,
    HTMLFormatterDecode

  ],
  providers: [
    HTMLFormatter, TranslateService, SanitizePipe,
    { provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher },
    // { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
    // {
    //   provide: NGX_MAT_DATE_FORMATS, useValue: {
    //     parse: {
    //       dateInput: "DD MMM YYYY"
    //     },
    //     display: {
    //       dateInput: "DD MMM YYYY",
    //       monthYearLabel: "MMM YYYY",
    //       dateA11yLabel: "DD MMM YYYY",
    //       monthYearA11yLabel: "MMMM YYYY"
    //     }
    //   }
    // }
    {
      provide: NGX_MAT_DATE_FORMATS,
      useValue: {
        useUtc: false,
        parse: {
          dateInput: { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit" },
          useUtc: false
        },
        display: {
          // dateInput: { year: "numeric", month: "2-digit", day: "2-digit" },
          monthInput: { month: "long" },
          dateInput: { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit" },
          timeInput: { hour: "2-digit", minute: "2-digit" },
          monthYearLabel: { year: "numeric", month: "short" },
          dateA11yLabel: { year: "numeric", month: "long", day: "numeric" },
          monthYearA11yLabel: { year: "numeric", month: "long" },
          popupHeaderDateLabel: { weekday: "short", month: "short", day: "2-digit" }
        },
      }
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter
    }
  ]
})



// { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }

export class DynamicControlsModule { }
